import angular from 'angular'

// components
import titleBarComponent from './component/titleBarComponent'

export default angular
  .module('portalApp.titleBarComponent', [])
  .component('titleBarComponent', titleBarComponent).name
